module.exports = __webpack_public_path__ + "static/media/hat.437339a2.svg";